import { Box, Grid, Stack, Chip, Typography, Button } from '@mui/material';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import { useNavigate } from 'react-router-dom';
import {
  getToken,
  getRole,
  getStageNumber,
} from '../../../utils/auth-token-utils/cookie';

const NotFound = () => {
  const token = getToken();
  const role = getRole();
  const stage = getStageNumber();
  const navigate = useNavigate();
  const handleBack = () => {
    if (token && role === 'Supervisor') {
      console.log('line 16');
      if (stage === '1') {
        navigate('/supervisor/createProfile');
      } else {
        navigate('/supervisor/dashboard');
      }
    } else if (token && role === 'Participant') {
      console.log('line 22');
      if (stage === '4') {
        navigate('participant/dashboard');
      } else if (stage === '3') {
        navigate('/participant/selectplan');
      } else if (stage === '2') {
        navigate('/participant/inviteBabysitter');
      } else {
        navigate('/participant/createProfile');
      }
    } else {
      console.log('line 32');
      navigate('/');
    }
  };
  return (
    <StyledBgContainer>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <Chip
          label="ERROR 404"
          sx={{
            color: '#F55A5A',
            backgroundColor: '#FAEAE9',
            height: '34px',
            width: '111px',
          }}
        />
        <Typography
          variant="h1"
          sx={{
            fontSize: {
              xs: '45px',
              sm: '112px',
            },
            color: 'secondary.main',
          }}
        >
          OOPS ...
        </Typography>
        <Typography
          variant="h1"
          sx={{
            fontWeight: 500,
            fontSize: {
              xs: '38px',
              sm: '48px',
            },
            color: 'secondary.main',
          }}
        >
          Page not found
        </Typography>

        <Typography
          variant="h5"
          sx={{
            lineHeight: '30px',
            fontSize: {
              xs: '16px',
              sm: '18px',
            },
            color: 'text.main',
          }}
        >
          The page you are looking for either doesn’t exist or any other error
          occurred, you can wait or reload again to resolve this issue.
        </Typography>
        <Button variant="contained" sx={{ width: '10vw' }} onClick={handleBack}>
          Go Back
        </Button>
      </Box>
    </StyledBgContainer>
  );
};

export default NotFound;
